/** True when development-only diagnostics should be collected and emitted. */ export const developmentDiagnosticsEnabled = typeof process === 'undefined' || process.env.NODE_ENV !== 'production';
